import {Component} from "@angular/core";
import {AuthService} from "./core/authentication/authentication.servicie";
import {Router, RouteConfigLoadStart, RouteConfigLoadEnd} from "@angular/router";
import { environment,mixpannelProjectToken } from "../environments/environment";
import { LocalizeService } from "./core/services/localize.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loading: boolean;

  constructor(private authService: AuthService, private router: Router,private localService:LocalizeService) {
    console.log(environment.CENTRAL_AUTH_URL,"token")
  let currentLang = localStorage.getItem('currentLang');
    this.localService.getTranslation(currentLang).subscribe(resp=>{})
    this.authService.menusLoadingSubject.subscribe((loading)=> {
      this.loading = loading;
    });
    this.router.events.subscribe((event)=> {
      if (event instanceof RouteConfigLoadStart) {
        this.loading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loading = false;
      }
    });
  }

}
